var render = function render(_c,_vm){return _c('router-link',{ref:"link",attrs:{"to":_vm.props.href,"active-class":_vm.props.activeClass,"exact-active-class":_vm.props.exactActiveClass,"exact":_vm.props.href == '/'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }